import { Heading, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';

export const AuthHeading = ({ children, ...restProps }: { children: ReactNode; [x: string]: any }) => (
  <Heading
    textAlign='center'
    fontStyle='italic'
    fontWeight='normal'
    size={{ base: 'xl', sm: '2xl', '2xl': '3xl' }}
    color='cyan.500'
    {...restProps}
  >
    {children}
  </Heading>
);

export const AuthSecondHeading = ({ children, ...restProps }: { children: ReactNode; [x: string]: any }) => (
  <Text
    color='brand.fontColorWhite'
    textAlign='center'
    fontSize={{ base: 'xl', sm: '22px', 'md': '2xl' }}
    mt={{ base: 2, '2xl': 5 }}
    lineHeight='120%'
    {...restProps}
  >
    {children}
  </Text>
);
